
import { AppUser } from '@/services/firebase/modules/users/users.types'
import { computed, reactive, watchEffect, defineComponent } from 'vue'
import { useStore } from 'vuex'
import * as actions from '../../../../store/actions.type'
import AvatarBrowse from '@/components/General/AvatarBrowse.vue'
import { useAvatarBrowse } from '@/hooks/useAvatarBrowseHook'

export default defineComponent({
  name: 'UserPorfileBasic',
  components: {
    AvatarBrowse,
  },
  setup() {
    const store = useStore()
    const user = computed<AppUser>(() => store.getters['user/user'])
    const photoUrl = computed(() => user.value.photoUrl)
    const {
      isReset,
      isUploading,
      isDeleting,
      handlePhotoSelected,
      handleAvatarUpdate,
      handleAvatarDelete,
      handleAvatarReset,
    } = useAvatarBrowse(
      photoUrl,
      `user/${actions.UsersAction.UPDATE_BASIC_USER_PROFILE}`,
      `user/${actions.UsersAction.UPDATE_BASIC_USER_PROFILE}`,
    )

    // TODO: Handle whitespace in user name update
    const editForm = reactive({
      name: user.value.name,
      email: user.value.email,
    })

    const hasChanged = computed(() => {
      if (user.value.name != editForm.name.trim() || !isReset.value) {
        return true
      }
      return false
    })

    watchEffect(() => {
      // watchEffect - We don’t watch one specific reactive value but every reactive value inside its callback function.
      editForm.name = user.value.name
      editForm.email = user.value.email
    })

    const rules = {
      email: [
        {
          required: true,
          message: 'Please input your email!',
          trigger: 'change',
        },
      ],
      name: [{ required: true, message: 'Please input Name!', trigger: 'change' }],
    }

    const handleUpdate = async () => {
      const data = {
        name: user.value.name != editForm.name.trim() ? editForm.name : null,
      }
      handleAvatarUpdate(user.value.id, data)
    }

    const handleReset = () => {
      editForm.name = user.value.name
      handleAvatarReset()
    }

    return {
      labelCol: {
        span: 4,
      },
      wrapperCol: {
        span: 14,
      },
      editForm,
      rules,
      hasChanged,
      photoUrl,
      isReset,
      isUploading,
      isDeleting,
      handleReset,
      handlePhotoSelected,
      handleUpdate,
      handleAvatarDelete,
    }
  },
})
